import './App.scss';

import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {nb} from "date-fns/locale"
import Login from './pages/login/login.component';
import { checkUserSession } from './redux/user/user.actions';
import { selectCurrentUser } from './redux/user/user.selectors';
import {registerLocale, setDefaultLocale} from "react-datepicker";
import ProjectRoutes from './components/project-routes/project-routes.component';

class App extends React.Component {
	componentDidMount() {
		const { checkUserSession } = this.props;
		checkUserSession();

        registerLocale('nb-NO', nb);
        setDefaultLocale('nb-NO');
	}

	render() {
		const { currentUser } = this.props;
		if (currentUser) {
			return <ProjectRoutes />;
		}
		return <Login />;
	}
}

const mapStateToProps = createStructuredSelector({
	currentUser: selectCurrentUser
});

const mapDispatchToProps = (dispatch) => ({
	checkUserSession: () => dispatch(checkUserSession())
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
